<template>
  <div class="main">
    <div class="row">
      <div class="col-xl-3 synops synops2">
        <div class="item">
          <span
            ><v-icon style="margin-bottom: 2px" class="ico" size="20"
              >mdi-domain</v-icon
            ></span
          >
          <span class="company-title">{{ company_name }}</span>
        </div>
        <div v-if="message" class="item">
          <span><v-icon class="ico msg">mdi-message</v-icon></span>
          <span>{{ message }}</span>
        </div>
        <div v-if="location_name" class="item">
          <span><v-icon class="ico msg">mdi-location</v-icon></span>
          <span>{{ location_name }}</span>
        </div>
      </div>
      <div class="col-xl-3 synops">
        <div class="item">
          <span
            ><v-icon style="margin-bottom: 2px" class="ico nme" size="20"
              >mdi-account-tie</v-icon
            ></span
          >
          <span class="u-name">{{ user_name }}</span>
        </div>
        <div class="item">
          <span><v-icon class="ico mail">mdi-email</v-icon></span>
          <span>{{ email }}</span>
        </div>
        <div class="item">
          <span><v-icon class="ico ph">mdi-phone</v-icon></span>
          <span>{{ phone }}</span>
        </div>
      </div>
      <div v-if="!registered" class="col-xl-2 synops synops2 my-auto">
        <button
                @click="deleteUser"
                class="btn btn-close"
        > Delete Company
        </button>
      </div>
      <!--<div class="col-xl-3 synops">-->
      <!--<div v-if="!featured">-->
      <!--<button @click="changeFeatureStatus('add')" class="btn btn-next-outline">Make Featured</button>-->
      <!--</div>-->
      <!--<div v-else>-->
      <!--<button @click="changeFeatureStatus('rem')" class="btn btn-prv-outline">Remove from Featured</button>-->
      <!--</div>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
import * as FILTER from "../../../filters";
import { required } from "vuelidate/lib/validators";
import { ADMIN_MAKE_FEATURED_COMPANY } from "../../../Api/admin_api";
export default {
  name: "job-synops",
  props: {
    job: Object,
    plans: Array,
    index: Number,
    registered: Boolean,
    action:{
      default:"no set",
      type:String
    }
  },
  validations: {
    plan: { required }
  },
  data: function() {
    return {
      user_name: null,
      company_id: null,
      company_name: null,
      email: null,
      phone: null,
      message: null,
      location_name: null,
      plan: null,
      planItems: [],
      paymentStatusItems: [
        {
          text: "On-Request",
          value: 2
        },
        {
          text: "Paid",
          value: 3
        }
      ],
      planStatus: 2,
      addDiscount: false,
      discount: null,
      featured: null,
      obj_type: null,
      act:this.action
    };
  },
  methods: {
    deleteUser() {
      const self = this;
      if (this.$route.query.q ==='duplicate') self.obj_type=48;
      else if(this.$route.query.q ==='duplicate-mail') self.obj_type=54;
      self.$emit("delete-user", self.company_id, self.index, self.obj_type );
    },
    changeFeatureStatus(status) {
      const self = this;
      let data = {
        company_id: self.company_id,
        op: status
      };
      ADMIN_MAKE_FEATURED_COMPANY(data)
        .then(function(resp) {
          self.featured = !self.featured;
        })
        .catch(function(err) {});
    }
  },
  mounted() {
    const self = this;
    if (self.job) {
      self.company_id = self.job.company_id;
      self.user_name = FILTER.FIRST_LETTER_CAPITAL(self.job.user_name);
      self.company_name = self.job.company_name;
      self.email = self.job.email;
      self.phone = self.job.phone;
      self.message = self.job.message || null;
      self.location_name = self.job.location_name || null;
      self.featured = self.job.featured || false;
    }
    if (self.plans && self.plans.length > 0) {
      self.planItems = self.plans.sort((a, b) =>
        parseInt(a.plan_id) > parseInt(b.plan_id) ? 1 : -1
      );
    }
  }
};
</script>

<style scoped>
.main {
  background-color: #ffffff;
}
.synops {
  padding: 15px;
  cursor: pointer;
}
.synops2 {
  /*border-left: 0.4rem solid var(--button-color);*/
}
.item {
  text-align: left;
  color: #050505;
  margin: 5px;
}
.company-title {
  font-size: 16px;
}
.u-name {
  font-size: 16px;
}
.ico {
  color: #506ee4;
  margin-right: 10px;
}
.msg {
  color: var(--button-color);
}
.nme {
  color: #5867dd;
}
.mail {
  color: #8187ff;
}
.ph {
  color: #1dc9b7;
}
.but {
  margin-top: 3rem;
}
.discount {
  position: relative;
}
.dis-close {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
